var _ = require('underscore');
var API = EY.Consultation.Lookups.API;
var DEBUG = EY.Consultation.DEBUG;

module.exports.log = function () {
    if (DEBUG && console) {
        console.log.apply(console, arguments);
    }
};

module.exports.logToServer = function (message, messageType,args) {
    var logger = new Backbone.Model();

    try {
        messageType = messageType || '';
        args = args || arguments;
        _.extend(logger, { urlRoot: API.Consultation + EY.Consultation.Lookups.Configuration.ApplicationLogCollection }).set({
            message: message,
            type:messageType,
            timestamp: new Date()
        }).save().done(function () {
            module.exports.log('Logged to server!', args);
        });
    } catch (e) {
        module.exports.log('Error logging message to server!', e);
    }
};

// This method will captures the log for each action performed in the record
module.exports.LogRecordAction = function (options) {
    var logger = new Backbone.Model();
    var message = {
        recordId: options.record.get('id'), // logs the record Id
        recordStatus: options.record.get('statusTypeId'),  // logs the status of the record
        action: options.action      // logs the action performed by user 
    };
    options.error && Object.assign(message, {error: options.error});  // logs the error if something is failed!
    try {
        _.extend(logger, { urlRoot: API.Consultation + EY.Consultation.Lookups.Configuration.ApplicationLogCollection }).set({
            message: JSON.stringify(message),
            type: 'UserAction',
            timestamp: new Date()
        }).save().done(function () {
            module.exports.log('Logged to server!');
        });
    } catch (e) {
        module.exports.log('Error logging message to server!', e);
    }
};


// WEBPACK FOOTER //
// ./js/Modules/Service/Logger.js